// import "animate.css"

import Vue from "vue"
import App from "./Documents.vue"

import "./assets/scss/_base.scss"
import vuetify from "./plugins/vuetify"

Vue.config.productionTip = false

import AOS from "aos"
import "aos/dist/aos.css"

new Vue({
  vuetify,
  render: (h) => h(App),
  mounted() {
    AOS.init()
  },
}).$mount("#app")
